export default {
    last_interaction_ticket: 'Comentou no chamado ',
}
